import { FormInstance } from 'antd';
import React, { FC, memo, ReactElement, useCallback } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { ConfirmModal } from 'shared/ui/ConfirmModal';
import { useChangeUserAddress } from '../utils/hooks/useChangeUserAddress';

interface ChangeUserAddressProps {
  userId: string | undefined;
  action: ReactElement;
  formInstance: FormInstance;
  onSuccess?: () => void;
}

export const ChangeUserAddress: FC<ChangeUserAddressProps> = memo((props) => {
  const { userId, action, formInstance, onSuccess } = props;

  const { t } = useAppTranslation('user');

  const updatedData = formInstance.getFieldsValue();

  const { handleChangeUserAddress, closeConfirmModal, openConfirmModal, isOpenedConfirm, isLoading } = useChangeUserAddress({
    userId,
    updatedData,
    onSuccess,
  });

  const handleClick = useCallback(async (): Promise<void> => {
    try {
      await formInstance.validateFields();
      openConfirmModal();
    } catch (e) {
      console.log(e);
    }
  }, [formInstance, openConfirmModal]);

  return (
    <>
      {React.cloneElement(action, { onClick: handleClick })}
      <ConfirmModal
        isOpened={isOpenedConfirm}
        title={t('Change account details')}
        description={t('Are you sure you want to change account details?')}
        isLoading={isLoading}
        onOk={handleChangeUserAddress}
        onCancel={closeConfirmModal}
      />
    </>
  );
});
